export enum MemberType {
    FELLOW = "Fellow",
    MEMBER = "MEMBER"
}